;(function () {
  'use strict'

  angular
    .module('admin.users.details.restrictions.service', [])
    .factory('RestrictionsService', RestrictionsService)

  /** @ngInject */
  function RestrictionsService($http, $q, API) {
    function update(id, body) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/permissions', body)
        .success(defered.resolve)
        .error(function (response) {
          swal(response.error.message, '', 'error')
        })

      return defered.promise
    }

    return {
      update: update,
    }
  }
})()
